/* Outback Maasai v10: small, dependency-free enhancements.
   Reveal on scroll · marquee pause · hero video · rails · gallery lightbox. */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || doc).querySelectorAll('[data-om10-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Marquee: pause button (remembered for the session) */
  function initMarquee(root) {
    (root || doc).querySelectorAll('[data-om10-mq]').forEach(function (mq) {
      if (mq.dataset.ready) return; mq.dataset.ready = '1';
      var btn = mq.querySelector('.om10-mq__toggle');
      var key = 'om10-mq-paused';
      function set(p) {
        mq.classList.toggle('is-paused', p);
        if (btn) { btn.setAttribute('aria-pressed', p ? 'true' : 'false'); btn.setAttribute('aria-label', p ? btn.dataset.playLabel : btn.dataset.pauseLabel); }
        try { sessionStorage.setItem(key, p ? '1' : '0'); } catch (e) {}
      }
      var stored = null; try { stored = sessionStorage.getItem(key); } catch (e) {}
      if (stored === '1') set(true);
      if (btn) btn.addEventListener('click', function () { set(!mq.classList.contains('is-paused')); });
    });
  }

  /* Hero video: only when motion is OK and data saver is off; poster image stays as LCP */
  function initHero(root) {
    (root || doc).querySelectorAll('[data-om10-hero-video]').forEach(function (v) {
      if (v.dataset.ready) return; v.dataset.ready = '1';
      var hero = v.closest('.om10-hero');
      var ctrl = hero && hero.querySelector('.om10-hero__ctrl');
      if (reduce.matches || saveData) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var src = (mobile && v.dataset.srcMobile) || v.dataset.srcDesktop;
      if (src && !v.currentSrc) { v.src = src; }
      v.muted = true; v.playsInline = true; v.loop = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); if (ctrl) ctrl.hidden = false; }, { once: true });
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!v.dataset.userPaused) play(); } else { v.pause(); } }); }, { threshold: 0.15 }).observe(v);
      } else { play(); }
      if (ctrl) ctrl.addEventListener('click', function () {
        if (v.paused) { delete v.dataset.userPaused; play(); ctrl.setAttribute('aria-pressed', 'false'); ctrl.setAttribute('aria-label', ctrl.dataset.pauseLabel); }
        else { v.dataset.userPaused = '1'; v.pause(); ctrl.setAttribute('aria-pressed', 'true'); ctrl.setAttribute('aria-label', ctrl.dataset.playLabel); }
      });
    });
  }

  /* Horizontal rails with prev/next */
  function initRails(root) {
    (root || doc).querySelectorAll('[data-om10-rail]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var rail = wrap.querySelector('[data-om10-rail-track]');
      var prev = wrap.querySelector('[data-om10-rail-prev]');
      var next = wrap.querySelector('[data-om10-rail-next]');
      if (!rail) return;
      function step() { var c = rail.querySelector(':scope > *'); return c ? c.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8; }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Gallery lightbox (native <dialog>) */
  function initLightbox(root) {
    (root || doc).querySelectorAll('[data-om10-gallery]').forEach(function (gal) {
      if (gal.dataset.ready) return; gal.dataset.ready = '1';
      var dlg = gal.querySelector('.om10-lb');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var shots = Array.prototype.slice.call(gal.querySelectorAll('[data-om10-shot]'));
      var img = dlg.querySelector('.om10-lb__stage img');
      var cap = dlg.querySelector('.om10-lb__cap');
      var count = dlg.querySelector('.om10-lb__count');
      var i = 0, lastFocus = null;
      function show(n) {
        i = (n + shots.length) % shots.length;
        var s = shots[i];
        img.src = s.dataset.full; img.alt = s.dataset.alt || '';
        cap.textContent = s.dataset.caption || '';
        if (count) count.textContent = (i + 1) + ' / ' + shots.length;
        var nxt = shots[(i + 1) % shots.length]; if (nxt) { var pre = new Image(); pre.src = nxt.dataset.full; }
      }
      shots.forEach(function (s, n) { s.addEventListener('click', function () { lastFocus = s; show(n); dlg.showModal(); }); });
      dlg.querySelector('.om10-lb__prev').addEventListener('click', function () { show(i - 1); });
      dlg.querySelector('.om10-lb__next').addEventListener('click', function () { show(i + 1); });
      dlg.querySelector('.om10-lb__close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('close', function () { if (lastFocus) lastFocus.focus(); });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      var x0 = null;
      var stage = dlg.querySelector('.om10-lb__stage');
      stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      stage.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); });
    });
  }

  function init(root) { initReveal(root); initMarquee(root); initHero(root); initRails(root); initLightbox(root); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
